import styled from '@emotion/styled'
import { PrebidModule } from '@pubstack/common/src/prebidModule'
import { Control, Controller, FieldErrors, UseFormSetValue, UseFormUnregister } from 'react-hook-form'
import { BaseInputElement } from '~/components/Input'
import { Toggle } from '~/components/Toggle'
import { ClassicFormPayload } from './CollapsiblePrebidModule'
import { PrebidModuleParamInput } from './PrebidModuleParamInput'

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  ${BaseInputElement}{
    width: 300px;
  }
`

const WaitForIt = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`

export type PrebidModuleClassicFormProps = {
  prebidModule: PrebidModule
  control: Control<ClassicFormPayload>
  errors: FieldErrors<ClassicFormPayload>
  isForbidden?: boolean
  setValue: UseFormSetValue<ClassicFormPayload>
  unregister: UseFormUnregister<ClassicFormPayload>
}

const BasePrebidModuleClassicForm = ({ prebidModule: { formParams, type }, control, errors, setValue, unregister, isForbidden }: PrebidModuleClassicFormProps) => {
  return (
    <FormWrapper>
      {Object.entries(formParams).map(([param, definition]) => (
        <PrebidModuleParamInput
          key={param}
          control={control}
          setValue={setValue}
          unregister={unregister}
          errors={errors}
          name={`config.moduleData.${param}`}
          param={definition}
          isForbidden={isForbidden}
        />
      ))}
      {type === 'RTD' && (
        <Controller
          control={control}
          name={'config.moduleData.waitForIt'}
          render={({ field: { onChange, value } }) => (
            <WaitForIt>
              <Toggle
                value={value}
                onClick={async () => {
                  onChange(!value)
                }}
                disabled={isForbidden}
                trackingLabel={value ? 'adm-integrations-modules-wait-for-it-unset' : 'adm-integrations-modules-wait-for-it-set'}
              />
              <p>Wait for it</p>
            </WaitForIt>
          )}
        />
      )}
    </FormWrapper>
  )
}

export const PrebidModuleClassicForm = BasePrebidModuleClassicForm
